import React, { useState } from "react";

const BrTabContent = () => {
  const [activeTab, setActiveTab] = useState(1);

  const updateToggle = (tabIndex) => {
    setActiveTab(tabIndex);
  };

  return (
    <div>
      {/* Tabs */}
      <div
        className="br_tabmenu_wrap justify-content-center"
        style={{ display: "flex", marginBottom: "10px" }}
      >
        <div
          className="br_tabmenu"
          onClick={() => updateToggle(1)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            backgroundColor: activeTab === 1 ? "#0d7a7a" : "#ffffff",
            borderRadius: "5px",
            marginRight: "5px",
            color: activeTab === 1 ? "#ffffff" : "#333333",
          }}
        >
          Student Course
        </div>
        <div
          className="br_tabmenu"
          onClick={() => updateToggle(2)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            backgroundColor: activeTab === 2 ? "#0d7a7a" : "#ffffff",
            borderRadius: "5px",
            marginRight: "5px",
            color: activeTab === 2 ? "#ffffff" : "#333333",
          }}
        >
          Professional Course
        </div>
        <div
          className="br_tabmenu"
          onClick={() => updateToggle(3)}
          style={{
            padding: "10px 20px",
            cursor: "pointer",
            backgroundColor: activeTab === 3 ? "#0d7a7a" : "#ffffff",
            borderRadius: "5px",
            color: activeTab === 3 ? "#ffffff" : "#333333",
          }}
        >
          Technical Training
        </div>
      </div>

      {/* Tab Content */}
      <div
        className="br_tab_content_wrap"
        style={{
          padding: "20px",
        }}
      >
        {activeTab === 1 && (
          <div className="br_tab_content">
            <div class="container-fluid bg-mainblue">
              <div class="container">
                <div
                  class="text-center mx-auto wow fadeInUp"
                  data-wow-delay="0.2s"
                  style={{ maxWidth: "800px" }}
                >
                  <div class="row br_academy_featue p-0 g-4">
                    <h4 class="brbrand_text_color text-center">
                      Student Course
                    </h4>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner1.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            INDUSTRY-SPECIFIC TRAINING
                          </h5>
                          <p class="mb-3 truncated-text">
                            Improve your digital skills with our focused
                            training, mastering today's essential digital
                            marketing strategies.
                          </p>
                          <a
                            href="https://www.bracadmy.com/technical-topic/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner2.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            STUDENT TRAINING PROGRAM
                          </h5>
                          <p class="mb-3 truncated-text">
                            Giving the essential skills for academic success and
                            future career readiness.
                          </p>
                          <a
                            href="https://www.bracadmy.com/technical-topic/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner3.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            CORPORATE PROGRAMS
                          </h5>
                          <p class="mb-3 truncated-text">
                            Improve your team's performance with targeted
                            training, boosting productivity and professional
                            growth.
                          </p>
                          <a
                            href="https://www.bracadmy.com/technical-topic/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner4.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            SOFT SKILLS & PROFESSIONAL DEVELOPMENT
                          </h5>
                          <p class="mb-3 truncated-text">
                            Master essential people skills and advance your
                            career with our professional development programs.
                          </p>
                          <a
                            href="https://www.bracadmy.com/technical-topic/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner5.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            PERSONAL GROWTH & LIFE SKILLS
                          </h5>
                          <p class="mb-3 truncated-text">
                            Cultivate inner strength and well-being with our
                            programs for personal development and life mastery.
                          </p>
                          <a
                            href="https://www.bracadmy.com/technical-topic/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner6.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            CUSTOMIZED TRAINING PROGRAMS
                          </h5>
                          <p class="mb-3 truncated-text">
                            We design customized programs to meet your unique
                            needs, driving specific, measurable results.
                          </p>
                          <a
                            href="https://www.bracadmy.com/technical-topic/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === 2 && (
          <div className="br_tab_content">
            <div class="container-fluid bg-mainblue">
              <div class="container">
                <div
                  class="text-center mx-auto wow fadeInUp"
                  data-wow-delay="0.2s"
                  style={{ maxWidth: "800px" }}
                >
                  <div class="row br_academy_featue p-0 g-4">
                    <h4 class="brbrand_text_color text-center">
                      Professional Course
                    </h4>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner7.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Advanced Project Management
                          </h5>
                          <p class="mb-3 truncated-text">
                            Master project execution, lead teams, and drive
                            successful outcomes.
                          </p>
                          <a
                            href="https://www.bracadmy.com/english-communication-skills/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner8.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Data Analytics for Business
                          </h5>
                          <p class="mb-3 truncated-text">
                            Transform raw data into actionable insights, driving
                            strategic business decisions.
                          </p>
                          <a
                            href="https://www.bracadmy.com/english-communication-skills/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner9.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Digital Marketing Strategy
                          </h5>
                          <p class="mb-3 truncated-text">
                            Craft impactful campaigns, build your brand, and
                            achieve measurable online success.
                          </p>
                          <a
                            href="https://www.bracadmy.com/english-communication-skills/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner10.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Leadership and Executive Communication
                          </h5>
                          <p class="mb-3 truncated-text">
                            Inspire teams, communicate effectively, and lead
                            with confidence at the executive level.
                          </p>
                          <a
                            href="https://www.bracadmy.com/english-communication-skills/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
        {activeTab === 3 && (
          <div className="br_tab_content">
            <div class="container-fluid bg-mainblue">
              <div class="container">
                <div
                  class="text-center mx-auto wow fadeInUp"
                  data-wow-delay="0.2s"
                  style={{ maxWidth: "800px" }}
                >
                  <div class="row br_academy_featue p-0 g-4">
                    <h4 class="brbrand_text_color text-center">
                      Technical Training
                    </h4>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner11.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Python Programming for Data Science
                          </h5>
                          <p class="mb-3 truncated-text">
                            Use Python's data science features discover data
                            insights and create strong models.
                          </p>
                          <a
                            href="https://www.bracadmy.com/corporate-training/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner12.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Cloud Computing with AWS
                          </h5>
                          <p class="mb-3 truncated-text">
                            Build scalable, secure, and innovative cloud
                            solutions using Amazon Web Services.
                          </p>
                          <a
                            href="https://www.bracadmy.com/corporate-training/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner16.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Cybersecurity Essentials
                          </h5>
                          <p class="mb-3 truncated-text ">
                            To protect your digital assets with essential
                            cybersecurity skills and threat mitigation
                            strategies.
                          </p>
                          <a
                            href="https://www.bracadmy.com/corporate-training/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner14.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Web Development with React
                          </h5>
                          <p class="mb-3 truncated-text">
                            Build dynamic, user-friendly web interfaces with
                            React's powerful component-based architecture.
                          </p>
                          <a
                            href="https://www.bracadmy.com/corporate-training/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>

                    <div
                      class=" col-md-6 col-lg-6 col-xl-4 wow fadeInUp"
                      data-wow-delay="0.2s"
                    >
                      <div class="feature-item text-left p-4">
                        <div class="feature-icon p-0 m-0">
                          <img
                            className="p-0"
                            src="assets/img/Bracademy/tab_banner15.jpg"
                            alt="BNR Cogniitec"
                          />
                        </div>
                        <div class="enroll_cours p-2">
                          <h5 className="course_title truncated-text2">
                            Database Management with SQL
                          </h5>
                          <p class="mb-3 truncated-text">
                            Efficiently manage and retrieve data with SQL,
                            ensuring database integrity and performance.
                          </p>
                          <a
                            href="https://www.bracadmy.com/corporate-training/"
                            class="p-0"
                          >
                            Read More
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default BrTabContent;
